import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';

export const BUSINESS_TZ = 'Europe/London';

/**
 * Convert a Date → UK business date string (yyyy-MM-dd)
 */
export const toBusinessDate = (date: Date): string => {
    return formatInTimeZone(date, BUSINESS_TZ, 'yyyy-MM-dd');
};

/**
 * Convert a UK business date string → UTC Date
 * Interprets the input as midnight in Europe/London
 */
export const fromBusinessDate = (dateStr: string): Date => {
    return fromZonedTime(`${dateStr}T00:00:00`, BUSINESS_TZ);
};

/**
 * Compare two dates by UK business day
 */
export const isSameBusinessDay = (a: Date, b: Date): boolean => {
    return toBusinessDate(a) === toBusinessDate(b);
};
